import { render, staticRenderFns } from "./CommonNoteModal.vue?vue&type=template&id=2687f31d&"
import script from "./CommonNoteModal.vue?vue&type=script&lang=js&"
export * from "./CommonNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports